import { proFormaCalcs } from "utils/proFormaCalcs";
import { yearOverYear } from "utils/yearOverYear";
import { calculatePhases } from "utils/phaseCalcs";

/**
 * Matches CostBenefitChart (All Sites): among electrification scenarios, pick the one
 * with the highest vehicleCounts[END_YEAR], then return cumulativeCostBenefit[EVAL_YEAR].
 */
export function getCumulativeCostBenefitAtEvalForMaxVehiclesScenario(
  fleetData,
  phasesRaw,
  advancedControls,
  controlsBase,
  cityInfo,
  chargerCost,
  years,
  includeMasterAccessIncentives,
) {
  const { EVAL_YEAR, END_YEAR } = years;
  const scenarioKeys =
    fleetData[0]?.electrification_scenario != null
      ? Object.keys(fleetData[0].electrification_scenario)
      : [];

  if (scenarioKeys.length === 0) {
    return 0;
  }

  let maxVehiclesAtEndYear = -Infinity;
  let cumulativeForMax = null;

  for (const scenarioKey of scenarioKeys) {
    const scenarioControls = {
      ...controlsBase,
      site: "All Sites",
      electrification_scenario: scenarioKey,
    };
    const pCalcs = proFormaCalcs(
      advancedControls,
      scenarioControls,
      fleetData,
      years,
    );
    const phaseResult = calculatePhases(
      phasesRaw,
      chargerCost,
      scenarioControls,
      cityInfo,
      includeMasterAccessIncentives,
    );
    const yoyForScenario = yearOverYear(
      fleetData,
      pCalcs,
      scenarioControls,
      advancedControls,
      years,
      phaseResult,
      chargerCost,
    );
    const vehiclesAtEnd = pCalcs.vehicleCounts[END_YEAR];
    const cumAtEval = yoyForScenario?.cumulativeCostBenefit?.[EVAL_YEAR];
    const v = Number(vehiclesAtEnd) || 0;
    if (v > maxVehiclesAtEndYear) {
      maxVehiclesAtEndYear = v;
      cumulativeForMax = cumAtEval;
    }
  }

  const n = Number(cumulativeForMax);
  return Number.isFinite(n) ? n : 0;
}
